import { Link } from '../../Link'
import { Container } from '../Container'

function Links() {
  return (
    <>
      <Container label='Link, default'>
        <Link to='/library/links'>Link</Link>
      </Container>
      <Container label='Link, default, disabled'>
        <Link disabled to='/library/links'>
          Link
        </Link>
      </Container>
      <Container label='Link, underline'>
        <Link to='/library/links' variant='underline'>
          Link
        </Link>
      </Container>
      <Container label='Link, underline, disabled'>
        <Link disabled to='/library/links' variant='underline'>
          Link
        </Link>
      </Container>
      <Container label='Link, secondary'>
        <Link to='/library/links' variant='secondary'>
          Link
        </Link>
      </Container>
      <Container label='Link, secondary, disabled'>
        <Link disabled to='/library/links' variant='secondary'>
          Link
        </Link>
      </Container>
    </>
  )
}

export default Links
